export default __webpack_public_path__ + "static/media/java.6cf9b956.svg";